module.exports = __webpack_public_path__ + "static/media/ios-copy.2a4db2cb.svg";